import { Mail } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import AttendanceButton from '~/components/AttendanceButton'
import { Button } from '~/components/ui/button'
import LearnerProfileView from '~/pages/backoffice/admin/user/profile/LearnerProfileView'
import ProfileActivityGrid from '~/pages/backoffice/admin/user/profile/ProfileActivityGrid'
import ProfileCertificates from '~/pages/backoffice/admin/user/profile/ProfileCertificates'
import ProfileLogins from '~/pages/backoffice/admin/user/profile/ProfileLogins'
import ProfilePositioning from '~/pages/backoffice/admin/user/profile/ProfilePositioning'
import ProfileSessions from '~/pages/backoffice/admin/user/profile/ProfileSessions'
import { demoLearner } from '~/pages/help/demo/demo-learner'
import DemoBanner from '~/pages/help/demo/DemoBanner'

/**
 * La fiche apprenant, en démonstration (#242) : la vraie vue, sur une personne fictive.
 * Sa route n'a pas d'id, donc le centre d'aide sait y lancer la visite ; rien ne s'y
 * envoie ni ne s'y télécharge.
 */
function LearnerProfileDemo() {
  const { t } = useTranslation()
  const { profile, sessions, logins, positioning } = demoLearner(t)
  const inert = () => toast.info(t('helpDemo.inert'))

  return (
    <>
      <DemoBanner backTo="/back-office/help" />
      <LearnerProfileView
        profile={profile}
        headerActions={(
          <Button variant="outline" onClick={inert}>
            <Mail className="mr-2 size-4" aria-hidden />
            {t('profile.email')}
          </Button>
        )}
      >
        <ProfileActivityGrid
          sessions={(
            <ProfileSessions
              sessions={sessions}
              renderAction={() => <AttendanceButton variant="ghost" size="sm" onClick={inert} loading={false}>{t('attendance.single')}</AttendanceButton>}
            />
          )}
          certificates={<ProfileCertificates sessions={sessions} onDownload={inert} />}
        />
        <ProfilePositioning sessions={positioning} />
        <ProfileLogins events={logins} />
      </LearnerProfileView>
    </>
  )
}

export default LearnerProfileDemo
